import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { statusAPI } from '../services/api';
import { ACTION_BUTTON_LABELS, getNextStatus } from '../utils/statusTransitions';

const ActionButton = ({ order, onUpdate }) => {
  const { selectedShop } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const nextStatus = getNextStatus(order.status);
  const label = ACTION_BUTTON_LABELS[order.status];

  // Spec: If Delivered or Cancelled, show NO action button
  if (!nextStatus || !label) return null;

  const handleStatusChange = async () => {
    try {
      setLoading(true);
      setError(null);
      await statusAPI.updateStatus(order.order_id, selectedShop, { status: nextStatus });
      // Trigger parent to re-fetch and slide the card to its new location
      if (onUpdate) onUpdate(); 
    } catch (err) {
      setError('Failed to update status');
    } finally {
      setLoading(false);
    }
  };

  // Spec: Button coloring
  const baseClasses = "px-5 py-2 text-sm font-bold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors flex items-center justify-center min-w-[140px] shadow-sm";
  const colorClasses = order.status === 'Ready'
    ? "bg-green-600 hover:bg-green-700 text-white focus:ring-green-500" // Green for Mark Delivered
    : "bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500";   // Blue for Pending / In Progress

  return (
    <div className="flex flex-col items-end">
      <button
        onClick={handleStatusChange}
        disabled={loading}
        className={`${baseClasses} ${colorClasses} ${loading ? 'opacity-75 cursor-wait' : ''}`}
      >
        {loading ? (
          <div className="flex items-center space-x-2">
            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Updating...</span>
          </div>
        ) : (
          label
        )}
      </button>
      {error && <span className="text-xs font-semibold text-red-500 mt-1">{error}</span>}
    </div>
  );
};

export default ActionButton;